import React from 'react';
import { FormHelperText } from '@mui/material';

interface ValidationMessagesProps {
  meta: {
    touched?: boolean;
    error?: string | string[];
  };
}

const ValidationMessages: React.FC<ValidationMessagesProps> = ({ meta }) => {
  if (!meta.touched || !meta.error) return null;

  return (
    <>
      {Array.isArray(meta.error) ? (
        meta.error.map((msg, idx) => (
          <FormHelperText key={idx}>{msg}</FormHelperText>
        ))
      ) : (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </>
  );
};

export default ValidationMessages;
